import { render, staticRenderFns } from "./BulkUnarchiveLearnersComponent.vue?vue&type=template&id=187597fe"
import script from "./BulkUnarchiveLearnersComponent.vue?vue&type=script&lang=js"
export * from "./BulkUnarchiveLearnersComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports